export default __webpack_public_path__ + "static/media/mvv.b636bc04.png";